export const EDX_URL = process.env.VERCEL_URL as string;

export const EDX_NAME = 'Escuela de Bajistas';
export const EDX_SHORT_NAME = 'EDB';
export const EDX_EMAIL = 'hola@escueladebajistas.com';

export const EDX_FAVICON_COLOR = '#FFFFFF';

export const EDX_META_DESCRIPTION =
  'En Escuela de Bajistas aprenderás a tocar el bajo con un método moderno y directo. Mejora tu técnica y conocimientos de manera fácil y rápida.';

export const EDX_GIFT_UPSELL_URL = '/regala-edb';

export const EDX_BENEFITS = [
  {
    title: 'Acceso ilimitado',
    description: 'Video-lecciones de todos los niveles y temáticas, actualizados día a día.',
  },
  {
    title: 'Audios y partituras',
    description: 'Podrás descargar partituras y backing tracks para practicar los ejercicios.',
  },
  {
    title: 'Guarda tu progreso',
    description: 'Historial personalizado con tus videos vistos y clases favoritas.',
  },
  {
    title: 'Comunidad',
    description: 'En nuestra comunidad, podrás conectar con otros bajistas y músicos.',
  },
];

export const EDX_TESTIMONIALS = [
  {
    quote:
      'Llevaba varios días dudando si inscribirme o no, pero hoy me animé y he de decir que es el dinero mejor invertido en años en lo que respecta al tiempo que llevo dedicado de manera aficionada a la música. Con solo un video he corregido vicios y posiciones que creí que eran correctas.',
    name: 'Sergio Zamorano',
    avatar: 'https://escueladebajistas.com/img/pricing/testimonials-sergio_zamorano.jpg',
  },
  {
    quote:
      'Como bajista autodidacta, hay muchas cosas que asumes y no sabes muy bien por qué las haces. Con los vídeos de EDB he conseguido entender qué estoy tocando sin sentarme y tener que aprender a leer partituras.',
    name: 'Gerard Rocha',
    avatar: 'https://escueladebajistas.com/img/pricing/testimonials-gerard_rocha.jpg',
  },
  {
    quote:
      'Las clases son muy concisas y directas al grano, en vez de pasarme 1 hora de clase, me concentro 5 minutos en una cosa específica y a practicar.',
    name: 'Marina Rodriguez',
    avatar: 'https://escueladebajistas.com/img/pricing/testimonials-marina_rodriguez.jpg',
  },
];

export const MAIN_MENU = [
  {
    text: 'Escuela',
    href: '/',
    subMenu: [
      {
        text: 'Cursos',
        href: '/cursos',
      },
      {
        text: 'Repertorio',
        href: '/repertorio',
      },
      {
        text: 'Itinerarios',
        href: '/itinerarios',
      },
      {
        text: 'Ejercicios',
        href: '/ejercicios',
      },
      {
        text: 'Consejos',
        href: '/consejos',
      },
      {
        text: 'Q&A',
        href: '/preguntas-y-respuestas',
      },
    ],
  },
  {
    text: 'Profesores',
    href: '/profesores',
  },
  {
    text: 'Cómo funciona',
    href: '/como-funciona',
    hideSubscribed: true,
  },
  {
    text: 'Precio',
    href: '/precio',
    hideSubscribed: true,
  },
  {
    text: 'Comunidad',
    href: '/comunidad',
  },
];
